module.exports = __webpack_public_path__ + "static/media/loader.4b1a1964.svg";